import React from 'react';
export function TestimonialsSection() {
  return <section className="py-20 bg-gray-50" data-id="element-803">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-804">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-805">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-806">
            What Our Users Say
          </h2>
          <p className="text-xl text-gray-600" data-id="element-807">
            Hear from creators who are growing their newsletter revenue with
            Newsfiliate
          </p>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-808">
          <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-809">
            <div className="p-8 md:p-10" data-id="element-810">
              <div className="flex flex-col md:flex-row items-center md:items-start gap-8" data-id="element-811">
                <div className="flex-shrink-0" data-id="element-812">
                  <div className="w-24 h-24 md:w-32 md:h-32 rounded-full overflow-hidden border-4 border-[#5e60ce]/20" data-id="element-813">
                    <img src="https://s3.us-east-1.amazonaws.com/cdn.getpoln.com/creatorboost/Simply-Stacie-4.jpg" alt="Stacie Vaughan" className="w-full h-full object-cover" data-id="element-814" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-815">
                  <div className="mb-6" data-id="element-816">
                    <svg className="h-8 w-8 text-[#5e60ce]/40 mb-4" fill="currentColor" viewBox="0 0 32 32" data-id="element-817">
                      <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" data-id="element-818" />
                    </svg>
                    <p className="text-lg md:text-xl text-gray-700 italic" data-id="element-819">
                      Newsfiliate makes it easy to monetize your newsletter with
                      Amazon affiliate links. I love being able to easily find
                      deals for products that will suit my audience and create
                      lists of products relevant to the content of my emails.
                    </p>
                  </div>
                  <div data-id="element-820">
                    <p className="font-bold text-gray-900" data-id="element-821">Stacie Vaughan</p>
                    <p className="text-[#5e60ce]" data-id="element-822">Simply Stacie</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}